<template>
    <div class="bin-card-monitoring-container">
    <div class="row">
      <div class="col-lg-12 stretch-card">
        <div class="card">

          <!-- Body -->
          <div class="card-body">
            <h4 class="card-title">RSM Reports</h4>
            <div class="filters">
              <div class="row mb-3">
                <div class="col-lg-3 col-md-3 col-12 text-left d-flex flex-column">
                  <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2 text-start"
                    @click="RSMGenerateReportModal = true; targetReportValueComputed = 'stockonhand';">
                    <i class="fas fa-file-export"></i>
                    Generate Stock On Hand Report
                  </button>
                  <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2 text-start"
                    id="dropdownMenuSizeButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-file-export"></i>
                    Generate Sales Transaction Report
                  </button>
                  <div class="dropdown-menu text-start" aria-labelledby="dropdownMenuSizeButton1">
                    <a class="dropdown-item" href="#" @click="RSMGenerateReportModal = true; targetReportValueComputed = 'invoice'">Sales Report</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#" @click="RSMGenerateReportModal = true; targetReportValueComputed = 'salessummary'">Sales Summary Report</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#" @click="RSMGenerateReportModal = true; targetReportValueComputed = 'salesreturn'">Returns Report</a>
                  </div>
                  <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2 text-start"
                    @click="RSMGenerateReportModal = true; targetReportValueComputed = 'deliverymonitoring';">
                    <i class="fas fa-file-export"></i>
                    Generate Delivery Monitoring Report
                  </button>
                  <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2 text-start"
                    @click="RSMGenerateReportModal = true; targetReportValueComputed = 'detailedaging';">
                    <i class="fas fa-file-export"></i>
                    Generate Detailed Aging Report
                  </button>
                  <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2 text-start"
                    @click="RSMGenerateReportModal = true; targetReportValueComputed = 'pdccollection';">
                    <i class="fas fa-file-export"></i>
                    Generate PDC Collection Report
                  </button>
                </div>
              </div>
            </div>
            <div>
              <lottie-animation style="height: 500px" :loop="true"
                :animationData="require('@/assets/lottie/report.json')" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- generate report modal -->
    <b-modal v-model="RSMGenerateReportModal" size="md" :title="targetReportDetails.title" hide-footer no-close-on-backdrop>
      <form class="forms-sample">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="chkReportType">Report Type</label>
              <div class="row">
                <div class="col">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input type="radio" class="form-check-input" value="regionalsales" v-model="reportType"
                        :disabled="isGenerating" />
                      RSM Report
                      <i class="input-helper"></i></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row" v-if="reportType == 'regionalsales' && targetReportDetails.target != 'stockonhand'">
          <div class="col">
            <div class="form-group">
              <label for="txtRSMCode">RSM Code</label>
              <multiselect id="txtRSMCode" v-model="value" placeholder="Search RSM Code" label="name" track-by="code"
                :options="rsmOptions" :multiple="true"></multiselect>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group" v-if="targetReportDetails.dateType == 'date'">
              <label for="txtReportDate">Report Date</label>
              <date-picker v-model="targetReportValueComputed.date" :clearable="false" format="MM/DD/YYYY"
                title-format="MM/DD/YYYY" time-title-format="MM/DD/YYYY" input-class="form-control"
                :input-attr="{ id: 'txtReportDate' }" :disabled="isGenerating" single></date-picker>
            </div>
            <div class="form-group" v-if="targetReportDetails.dateType == 'dateRange'">
              <label for="txtReportDateRange">Report Date Range</label>
              <date-picker v-model="targetReportValueComputed.dateRange" :clearable="false" format="MM/DD/YYYY"
                title-format="MM/DD/YYYY" time-title-format="MM/DD/YYYY" input-class="form-control"
                :input-attr="{ id: 'txtReportDateRange' }" :disabled="isGenerating" range></date-picker>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-check form-check-flat form-check-primary">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" v-model="targetReportValueComputed.isOfficial"
                  :disabled="isGenerating" />
                Is Official
                <i class="input-helper"></i></label>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <button type="button" class="btn btn-primary mr-2" @click="generateRSMTypeReport"
              :disabled="isGenerating">
              <i class="fas fa-spinner fa-spin mr-1" v-if="isGenerating" />
              Generate
            </button>
            <button type="button" class="btn btn-light" @click="
                        RSMGenerateReportModal = !RSMGenerateReportModal;
                        reportType = 'regionalsales';
                        " :disabled="isGenerating">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </b-modal>

  </div>
</template>
<script>
import { mapState } from "vuex";
import LottieAnimation from "lottie-web-vue";

export default {
    components: {
        LottieAnimation,
    },
    data() {
        return {
            // New
            targetReportDetails: {
                target: "stockonhand",
                title: "Stock on Hand RSM Report",
                uri: "GetStockOnHandRSMReports",
                dateType: "date"
            },
            RSMGenerateReportModal: false,

            // Old
            value: [],
            reportType: "regionalsales",
            isGenerating: false,
            file: null,
        };
    },
    computed: {
    ...mapState({
      principals: (state) => state.principalController.principals,

      // New
      regionalSales: (state) => state.regionalSalesController.regionalSales,
      stockOnHandReportFilter: (state) => state.reportController.stockOnHandReportFilter, // BIN Card for Principal Filter
      // Sales Transaction Filter
      invoiceListingReportFilter: (state) =>
        state.reportController.invoiceListingReportFilter,
      salesSummaryReportFilter: (state) =>
        state.reportController.salesSummaryReportFilter,
      salesReturnReportFilter: (state) =>
        state.reportController.salesReturnReportFilter,
      // Delivery Monitoring Filter
      deliveryMonitoringReportFilter: (state) =>
        state.reportController.deliveryMonitoringReportFilter,
      // Detailed Aging
      billCollectorReportFilter: (state) =>
        state.reportController.billCollectorReportFilter,
      // PDC Collection Filter
      PDCCollectionReportFilter: (state) =>
        state.reportController.PDCCollectionReportFilter,
    }),
    rows() {
      // return this.binCardReports.length;
      // return this.inventoryLevelReports.length;
    },
    principalOptions() {
      return this.principals.map((mg) => ({
        ["name"]: mg.principalCode,
        ["code"]: mg.principalCode + "-001",
      }));
    },
    // New
    rsmOptions() {
      return this.regionalSales.map((mg) => ({
        ["name"]: mg.rsmCode,
        ["code"]: mg.rsmCode + "-001",
      }));
    },
    targetReportValueComputed: {

        get() {
            switch(this.targetReportDetails.target) {
                case 'stockonhand' : return this.stockOnHandReportFilter;
                case 'invoice' : return this.invoiceListingReportFilter;
                case 'salessummary' : return this.salesSummaryReportFilter;
                case 'salesreturn' : return this.salesReturnReportFilter;
                case 'deliverymonitoring' : return this.deliveryMonitoringReportFilter;
                case 'detailedaging' : return this.billCollectorReportFilter;
                case 'pdccollection' : return this.PDCCollectionReportFilter;
                default: return this.stockOnHandReportFilter;
            }
        },
        set(value) {
            this.targetReportDetails.target = value;
            switch(this.targetReportDetails.target) {
                case 'stockonhand':
                    this.targetReportDetails.title = "Stock on Hand RSM Report";
                    this.targetReportDetails.dateType = "date";
                    this.targetReportDetails.uri = "GetStockOnHandRSMReports_V2";
                    break;
                case 'invoice':
                    this.targetReportDetails.title = "Invoice Listing Report";
                    this.targetReportDetails.dateType = "dateRange";
                    this.targetReportDetails.uri = "GenerateRSMInvoiceListing_V2";
                    break;
                case 'salessummary':
                    this.targetReportDetails.title = "Sales Summary Report";
                    this.targetReportDetails.dateType = "dateRange";
                    this.targetReportDetails.uri = "GenerateRSMSalesSummary_V2";
                    break;
                case'salesreturn':
                    this.targetReportDetails.title = "Sales Return Report";
                    this.targetReportDetails.dateType = "dateRange";
                    this.targetReportDetails.uri = "GenerateRSMSalesReturn_V2";
                    break;
                case 'deliverymonitoring':
                    this.targetReportDetails.title = "Delivery Monitoring Report";
                    this.targetReportDetails.dateType = "dateRange";
                    this.targetReportDetails.uri = "GetRSMDeliveryMonitoringReports_V2";
                    break;
                case 'detailedaging':
                    this.targetReportDetails.title = "Detailed Aging Report by Bill Collector";
                    this.targetReportDetails.dateType = "date";
                    this.targetReportDetails.uri = "GetBillCollectorReportsRSM_V2";
                    break;
                case 'pdccollection':
                    this.targetReportDetails.title = "PDC Collection Report";
                    this.targetReportDetails.dateType = "";
                    this.targetReportDetails.uri = "GetPDCCollectionRSMReports_V2";
                    break;
            }
        },
    },
  },
  validations: {
    stockOnHandReportFilter: {
      // dateRange: {
      //   required,
      // },
    },
    invoiceListingReportFilter: {},
    salesSummaryReportFilter: {},
    salesReturnReportFilter: {},
    deliveryMonitoringReportFilter: {},
    billCollectorReportFilter: {},
    PDCCollectionReportFilter: {},
  },
  watch: {
    reportType: {
      handler() {
        this.value = [];
      },
      deep: true,
    },
  },
  methods: {
    // New
    async generateRSMTypeReport() {
        // this.$v.$touch();

        // if (!this.$v.inventoryLevelReportFilter.$invalid) {
        this.isGenerating = true;
        this.targetReportValueComputed.principalCode = this.value
          .map((mg) => mg.name)
          .join("~");

        var result = false;
        result = await this.$store
            .dispatch(`reportController/${this.targetReportDetails.uri}`)
            .catch(async (error) => {
                this.isGenerating = false;
                await this.$store.dispatch("showOverlay", false);
                this.$toast.open({
                message: error.data.Message,
                type: "error",
            });
        });

        if (result) {
            this.RSMGenerateReportModal = false;
            this.reportType = "regionalsales";
            this.isGenerating = false;
            this.value = [];

            this.$toast.open({
                message: "Report has been saved.",
                type: "success",
            });
        }
        // }
    },
    
    // Old
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    generateReport() {
      this.$toast.open({
        message: "This feature is not yet implemented.",
        type: "info",
      });
    },
    
    searchFilter: async function () {},
  },
  async mounted() {
    await this.searchFilter();
  },
};
</script>

<style scoped>
.mx-datepicker-range {
  width: 100%;
}
</style>